import { useEffect } from 'react';

type Variable = '--header-sticky-height' | '--calendly-modal-height';

export function useSetGlobalCssVariable(variable: Variable, value: string) {
    useEffect(() => {
        document.body.style.setProperty(variable, value);

        return () => {
            document.body.style.removeProperty(variable);
        };
    }, [variable, value]);
}
